import { fetchPost, fetchPut, fetchGet, fetchDelete } from '@/utils/request'

export function getBusinessList (query) { //商户列表、搜索
    return fetchGet('/gateway/v1/saas-companies', query)
}
export function getBrokersList (query) { //经纪人列表
  return fetchGet('/gateway/v1/saas-brokers', query)
}
export function getBrokerHousesList (query) { //经纪人绑定楼盘列表
  return fetchGet('/gateway/v1/broker-houses', query)
}
export function setBrokerAccount (query) { //经纪人设为坐席账号
  return fetchPut('/gateway/v1/seat-account', query)
}